<app-pcbread-crumb [data]="'Finance,POSDevice'"></app-pcbread-crumb>
<app-pccrud [endPoint]="'POSDevice'"></app-pccrud>